import React, { Component } from "react"
import { smoothSailing } from "../lib/scrolling"
import classNames from "classnames"
import { injectIntl, IntlContextConsumer, changeLocale } from "gatsby-plugin-intl"

const languageName = {
  en: "English",
  fr: "Français",
}

class Nav extends Component {
  handleClick = (e, id) => {
    e.preventDefault()

    smoothSailing({
      destination: document.getElementById(`section-left-${id}`),
      callback: () => this.props.setActive(id)
    })
  }

  render() {
    const { active, intl, small } = this.props

    const links = [
      {
        id: "1",
        label: `${intl.formatMessage({ id: "navIntroduction" })}`,
      },
      {
        id: "3",
        label: `<span>1.</span><span>${intl.formatMessage({ id: "navDepeindre" })}</span>`,
      },
      {
        id: "4",
        label: `<span>2.</span><span>${intl.formatMessage({ id: "navVoyager" })}</span>`,
      },
      {
        id: "5",
        label: `<span>3.</span><span>${intl.formatMessage({ id: "navImaginer" })}</span>`,
      },
      {
        id: "6",
        label: `<span>4.</span><span>${intl.formatMessage({ id: "navTransmettre" })}</span>`,
      },
      {
        id: "7",
        label: `${intl.formatMessage({ id: "navRessources" })}`,
      },
    ]


    return (
      <div className={classNames("site-nav", { small })}>
        <nav className={classNames("site-nav__nav", { active })}>
          <ul className="nav">
            {links.map(link => {
              return (
                <li key={link.id} className={classNames("nav__link", { "active": (active === parseInt(link.id)) })}>
                  <a
                    href={`#section-left-${link.id}`}
                    onClick={e => this.handleClick(e, link.id)}
                    dangerouslySetInnerHTML={{ __html: link.label }}
                  />
                </li>
              )
            })}
            <IntlContextConsumer>
              {({ languages, language: currentLocale }) =>
                languages.map(language => {

                  // const removeLocalePart = pathname => {
                  //   const { routed } = window.___gatsbyIntl
                  //   if (!routed) {
                  //     return pathname
                  //   }
                  //   const i = pathname.indexOf(`/`, 1)
                  //   return pathname.substring(i)
                  // }

                  // const pathname = to || removeLocalePart(window.location.pathname)
                  // // TODO: check slash
                  // const link = `/${language}${pathname}${window.location.search}`

                  // console.log('link', link)

                  return (
                    <li key={language}>
                      {currentLocale !== language && <a
                        // onClick={() => changeLocale(language, `/`)}
                        href={`/annesavage/${language}`}
                        style={{
                          cursor: `pointer`,
                        }}
                      >
                        {languageName[language]}
                      </a>}
                    </li>
                  )
                })
              }
            </IntlContextConsumer>
          </ul>
        </nav>
      </div>
    )
  }
}

export default injectIntl(Nav)
